// MATERIAL-UI
import { Grid, Tooltip } from "@mui/material";

// ASSETS
import { MarketTableStyles } from "./Table/styles/MarketTable.styles";

interface RankProps {
  rank: number;
  isActive?: boolean;
}
const Rank = (props: RankProps) => {
  const { rank, isActive } = props;
  const classes = MarketTableStyles();

  const tooltipTitle = (rank: number) => {
    if (isActive) {
      return `Rank #${rank}`;
    } else if (!isActive) {
      return "Inactive";
    } else {
      return "";
    }
  };

  return (
    <Tooltip title={tooltipTitle(rank)}>
      <Grid container justifyContent="center" alignItems="center" className={classes.rank}>
        {rank}
      </Grid>
    </Tooltip>
  );
};

export default Rank;
